import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { ButtonV3 } from 'components/ComponentV2';
import { PAGE_ROUTES } from 'lib/page-routes';

import styles from './NoDiscussions.module.scss';

const NoDiscussions = () => {
  const [t] = useTranslation('discussions');
  const router = useRouter();
  const onExploreCommunities = () => router.push(PAGE_ROUTES.SOCIETIES_SEARCH);

  return (
    <section className={styles.container}>
      <div className={styles.content}>
        <p className={styles.emoji}>🙄</p>
        <p className={styles.description}>{t('discussions-in-messages.no-discussion.description')}</p>
        <ButtonV3 size="large" startIcon="icon_compass" onClick={onExploreCommunities}>
          {t('discussions-in-messages.no-discussion.action')}
        </ButtonV3>
      </div>
    </section>
  );
};

NoDiscussions.displayName = 'NoDiscussions';

export default NoDiscussions;
